import { useSetRecoilState } from "recoil";
import { usersAtom } from "../miscellaneous/usersAtom";

export const useSetUsersState = () => {
    return useSetRecoilState(usersAtom);
};
